var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-header-wrp display-flex"},[(_vm.previousSteps.length > 0)?_c('div',{staticClass:"pr-3"},[_c('v-btn',{staticClass:"back-button",attrs:{"width":"25","height":"25","fab":"","x-small":""},on:{"click":function($event){return _vm.$emit('prevStep')}}},[_c('AppIcon',{attrs:{"name":"back"}})],1)],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }